module.exports = __webpack_public_path__ + "d66add457c2cd12362432c0ce62b610c.png";